import headerStyle from "./header.module.css";

import logo from "../../assets/PentraLogoDarkFull.png"
import { CircleUserRound as Profile, Settings, LogOut, ChevronDown as DownArrow } from "lucide-react";

import { useAuth0 } from "@auth0/auth0-react";

function Header() {
  const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();

  function getAccountDropdown() {
    if (!isAuthenticated || user === undefined) {
      return (
        <button className={headerStyle.flexHorizontal + " " + headerStyle.lastLink} onClick={() => loginWithRedirect()}>
          Log In
        </button>
      );
    }

    return (
      <div className={headerStyle.dropdown}>
        <div className={headerStyle.dropdownImage}>
          <img alt="Profile" className={headerStyle.portrait} src={user.picture} />
          <DownArrow className={headerStyle.arrow} stroke="white" strokeWidth="1.5" />
        </div>

        <div className={headerStyle.dropdownContent}>
          <a className={headerStyle.flexHorizontal} href="/account">
            <Profile className={headerStyle.dropdownIcons} stroke="white" strokeWidth="1.5" />
            Account
          </a>
          <a className={headerStyle.flexHorizontal} href="/settings">
            <Settings className={headerStyle.dropdownIcons} stroke="white" strokeWidth="1.5" />
            Settings
          </a>
          <button
            onClick={() => {
              logout({ logoutParams: { returnTo: window.location.origin } })}
            }
            className={headerStyle.flexHorizontal + " " + headerStyle.barUp}
          >
            <LogOut className={headerStyle.dropdownIcons} stroke="white" strokeWidth="1.5" />
            Log out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={headerStyle.navParent}>
      <div className={headerStyle.navContent}>
        <a href="/" className={headerStyle.logo}>
          <img className={headerStyle.logoImage} src={logo} key={logo} alt="Pentra Logo" />
        </a>
        <div className={headerStyle.navLinksWrapper}>
          <a className={headerStyle.flexHorizontal + " " + headerStyle.lastLink + " " + headerStyle.shadow} href="https://forms.clickup.com/9012284278/f/8cjt2vp-8012/6IEF36QLCAHFW7YCX4">
            Feedback
          </a>
          <a className={headerStyle.flexHorizontal + " " + headerStyle.lastLink} href="/downloads">
            Installations
          </a>
          <a className={headerStyle.flexHorizontal + " " + headerStyle.lastLink} target="_blank" href="https://docs.pentra.ai">
            Docs
          </a>
          <a className={headerStyle.flexHorizontal + " " + headerStyle.lastLink} href="/">
            Pentests
          </a>
          {getAccountDropdown()}
        </div>
      </div>
    </div>
  );
}

export default Header;
